import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static values = {
    period: Number    // timeout in Seconds
  }

  connect() {
    // console.log("Hello, Timeout!", this.element);

    // Do this instead
    setTimeout(() => {
      console.log(`Timeout after ${this.periodValue} seconds`);
      const modalElm= document.querySelector('#timeout_modal')
      const modalOptions={};

      let modal = bootstrap.Modal.getOrCreateInstance(modalElm, modalOptions);
      if (modal) {
        modal.show();
      }
    }, this.periodValue * 1000);

  }
}
